module.exports = __webpack_public_path__ + "static/img/pj1-1.8a83334.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/pj1-1.png
// module id = 710
// module chunks = 0